import React, { useState } from 'react';
import {
  Paper,
  Badge,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/core/styles';

const Expander = ({ title, count, children, classes }) => {
  const [isOpen, setIsOpen] = useState(true);

  const expanderClick = e => {
    setIsOpen(!isOpen);
  }

  return (
    <Paper className={classes.paper}>
      <Accordion expanded={isOpen} classes={{ root: classes.panelRoot }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={expanderClick}
          classes={{
            root: classes.summaryRoot,
            content: classes.summaryContent,
            expandIcon: classes.expandIcon,
          }}
        >
          <div className={classes.expanderTitle}>
            <Typography className={classes.heading}>{title}</Typography>
            {count &&
              <Badge badgeContent={count} color='primary'
                classes={{ root: classes.root, colorPrimary: classes.colorPrimary, badge: classes.badge }}
                max={999}
                overlap='rectangular'
              >
                <div />
              </Badge>
            }
          </div>
        </AccordionSummary>
        <AccordionDetails classes={{ root: classes.detailsRoot }}>
          {children}
        </AccordionDetails>
      </Accordion>
    </Paper>
  )
}

// for overriding Badge CSS
const styles = theme => ({
  root: {
    position: 'relative',
    display: 'inline-flex',
    margin: '6px 0px 0px 20px',
    // For correct alignment with the text.
    verticalAlign: 'middle',
  },
  colorPrimary: {
    backgroundColor: theme.palette.primary.main, //'#8c8c8c', '#999999'
    color: theme.palette.primary.contrastText,
  },
  badge: {
    top: '5px',
  },

  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.contrastText,
  },
  panelRoot: {
    margin: 0,
    '&:before': {
      opacity: 1
    },
    overflow: 'hidden'
  },
  summaryRoot: {
    minHeight: '36px !important',
    backgroundColor: theme.palette.secondary.main,
    display: 'flex',
    alignItems: 'center',
  },
  summaryContent: {
    margin: '5px 0 !important',
    whiteSpace: 'nowrap'
  },
  detailsRoot: {
    flexDirection: 'column',
    padding: '0 16px 16px',
    maxHeight: '250px',
    overflow: 'auto'
  },
  expandIcon: {
    color: '#fff',
    padding: 4
  },
  expanderTitle: {
    display: 'flex',
    flexGrow: 2
  },
  paper: {
    margin: '8px 0'
  }
});

export default withStyles(styles)(Expander);
